import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Pagination } from '../@config';
import { ENDPOINTS } from '../@config/endpoints';
import { EventEntry, EventResult, ReminderEntry, TaskEntry, TaskResult } from '../@models';
import { AppState } from '../@store';

@Injectable({
  providedIn: 'root'
})
export class FeedService {

  constructor(private store: Store, private http: HttpClient) { }

  private getSearchText(searchFilter: any): string {
    if (typeof searchFilter === 'string') {
      return searchFilter;
    }

    if (searchFilter && typeof searchFilter === 'object') {
      if (typeof searchFilter.payload === 'string') {
        return searchFilter.payload;
      }

      if (typeof searchFilter.filterString === 'string') {
        return searchFilter.filterString;
      }
    }

    return '';
  }

  getTasks(skipCount: number, searchFilter:any): Observable<TaskResult> {
    const userId = this.store.selectSnapshot(AppState.userId);
    const searchText = this.getSearchText(searchFilter);
    return this.http.get<TaskResult>(ENDPOINTS.getTasks(userId, Pagination.maxResultCount, skipCount, searchText)).pipe(
      map((respone: any) => respone?.result || []));
  }

  getEvents(skipCount: number, searchFilter:any): Observable<EventResult> {
    const userId = this.store.selectSnapshot(AppState.userId);
    const searchText = this.getSearchText(searchFilter);
    return this.http.get<EventResult>(ENDPOINTS.getEvents('0', Pagination.maxResultCount, skipCount, searchText)).pipe(
      map((respone: any) => respone?.result || []));
  }

  getReminders(startDate: string, endDate: string): Observable<ReminderEntry[]> {
    return this.http.get<ReminderEntry[]>(ENDPOINTS.getReminders(startDate, endDate)).pipe(
      map((response: any) => {
        const result = response?.result;

        if (Array.isArray(result)) {
          return result;
        }

        if (Array.isArray(result?.items)) {
          return result.items;
        }

        return [];
      }));
  }
}
